import React from 'react';
import { connect } from 'react-redux';
import DynamicformInit from "../DynamicformInit";
import { updateData, resetFormData, resetEditFormData } from "../actions";
import ControlService from "../../helper/controlservice";
import { Tabs, Tab } from "react-bootstrap";
import Loading from '../../helper/component/Loading';
import { isBrowser } from "react-device-detect";
import { actionType, ruleCheck } from "../../helper/common/rules";

const mapStateToProps = state => ({
    data: state.formDataReducer,
    token: state.formLoginReducer.token,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading
});
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
        resetEditData: (data) => dispatch(resetEditFormData(data)),
        resetData: (data, storekey) => dispatch(resetFormData(data, storekey)),
    };
}
class TabUI extends React.PureComponent {
    state = {
        isApiCalling: false,
        selectedTab: null,
        advanceSearchformJson: null,
        selectedTabKey: 0
    }
    componentDidMount() {
        const { control, data, formid, action } = this.props;
        this.InitializeTab(control, data[formid + action] ? data[formid + action][control.key] : null);
    }
    InitializeTab(control, data) {
        var defaulttabindex = control.defaulttabindex && control.defaulttabindex >= 0 ? control.defaulttabindex : 0;
        if (control.IsExternalFormLoad && control.children.length > 0) {
            let selectedTabKey = control.children[defaulttabindex] ? control.children[defaulttabindex].formid : "0";
            this.setState({ selectedTabKey: data ? data : selectedTabKey });
            if (!data)
                this.props.update(control.key, selectedTabKey, this.props.formid + this.props.action);
        } else if (control.IsImageButtonView && control.children.length > 0) {
            let key = data ? data : control.children[defaulttabindex] ? control.children[defaulttabindex].label : "key";
            let tab = control.children.find(x => x.label == key);
            this.ResetChildren(tab, control, true);
        } else if (control.IsButtonView || control.IsImageButtonView || control.IsExternalFormLoad) {
            let key = data ? data : control.children[defaulttabindex] ? control.children[defaulttabindex].label : "key";
            let tab = Array.isArray(control.children) ? control.children.find(x => x.label == key) : {};
            this.ResetChildren(tab, control, true);
        } else if (control.children.length > 0) {
            let key = data ? data : control.children[defaulttabindex] ? control.children[defaulttabindex].label : "0";
            this.setState({ selectedTabKey: key });
            this.props.update(control.key, key, this.props.formid + this.props.action);
        }
    }
    loadMetadata(formid, action) {
        this.setState({
            advanceSearchformJson: null,
            isApiCalling: true
        });

        ControlService().loadMetadata(formid, this.props.token)
            .then(data => {

                this.setState({
                    advanceSearchformJson: data
                })
                this.loadModelData(data, action);
            })
            .catch(err => {
                this.setState({
                    isApiCalling: false
                })
            });
    }
    loadModelData(formUI, action) {
        var url = formUI.GetEndpoint;
        if (url) {
            var data = this.props.data[this.props.formid + action] ? this.props.data[this.props.formid + action] : {}
            var apiparam = {}
            formUI.GetEndpointParams.forEach(option => {
                if (this.props.pageparams && this.props.pageparams[option.value]) {
                    apiparam[option.key] = this.props.pageparams[option.value];
                }
                else {
                    var paramVal = ControlService().GetParamUrl(option.value)
                    if (paramVal) {
                        apiparam[option.key] = paramVal;
                    } else if (data[option.value] || data[option.value] == false) {
                        apiparam[option.key] = data[option.value];
                    }
                    else {
                        apiparam[option.key] = option.value;
                    }
                }
            })
            ControlService().loadModelData(url, apiparam, this.props.token)
                .then(res => {
                    let datamodel = Array.isArray(res) && res.length > 0 ? res[0] : res;
                    ControlService().GenerateDataJson(formUI.controls, datamodel);
                    this.props.resetData(datamodel, formUI.Id + action);
                    this.setState({
                        isApiCalling: false
                    });
                })
                .catch(err => {
                    let datamodel = formUI.ModelJson;
                    ControlService().GenerateDataJson(formUI.controls, datamodel);
                    this.props.resetData(datamodel, formUI.Id + action);
                    this.setState({
                        isApiCalling: false
                    });
                });
        } else {
            let datamodel = formUI.ModelJson;
            ControlService().GenerateDataJson(formUI.controls, datamodel);
            this.props.resetData(datamodel, formUI.Id + action);
            this.setState({
                isApiCalling: false
            });
        }
    }
    tabChange(event) {
        this.setState({ selectedTabKey: event });

        this.props.update(this.props.control.key, event, this.props.formid + this.props.action);

        // this.loadMetadata(event);
    }
    ResetChildren(tab, control, firstLoad = false) {

        if (tab) {
            this.setState({ selectedTab: tab, selectedTabKey: tab.label });
            if (tab.formid) {
                this.loadMetadata(tab.formid, tab.formactiontype);
            }
            if (!firstLoad) {
                this.clearButtonViewData(control, tab);
            } else {
                this.props.update(control.key, tab.label, this.props.formid + this.props.action);
            }
        }
    }
    clearButtonViewData(control, tab) {
        const { action, formid } = this.props;
        if (!control.IsallowChilddata) {
            var datamodel = this.props.data[formid + action] ? this.props.data[formid + action] : {};

            ControlService().GenerateDataJson(control.children, datamodel, null, true);
            datamodel[control.key] = tab.label;
            this.props.resetData(datamodel, formid + action);
        } else {
            this.props.update(control.key, tab.label, formid + action);
        }
    }
    loadTab(control, data) {
        debugger;
        return (
            control.children.map((tab, i) => {
                return (
                    actionType(tab.rules) === 'hide' || actionType(tab.rules) === 'show' ?
                        ruleCheck(tab.rules, data, this.props.data) ? this.renderTab(tab, control, i, false) : null
                        : actionType(tab.rules) === 'disable' || actionType(tab.rules) === 'enable' ?
                            this.renderTab(tab, control, i, true)
                            : this.renderTab(tab, control, i, false)
                )
            })
        )
    }
    renderTab(tab, control, i, isDisable) {
        return <Tab disabled={isDisable} key={tab.id} eventKey={tab.formid ? tab.formid : tab.id} title={<span>{tab.tabicon ? <i className={tab.tabicon + " icon-remove" + (tab.Header ? 'mr-2' : null)} /> : null} {tab.Header} </span>}>
            {this.state.selectedTabKey == tab.formid ?
                <DynamicformInit formid={tab.formid}
                    dataid={''}
                    formui={null}
                    datamodel={null}
                    access={'write'}
                    pageparams={{}}
                    authtoken={this.props.token} />
                : null}
            {control.showoptionabutton ?
                <div className="pt-3">
                    {i == 0 ?
                        <div className="d-flex justify-content-end mb-3">
                            <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => this.tabChange(control.children[i + 1].formid ? control.children[i + 1].formid : control.children[i + 1].id)}>
                                <i className="fa fa-arrow-right pl-2"></i>{control.optionabuttonText ? control.optionabuttonText : control.children[i + 1].Header}
                            </button>
                        </div>
                        : i > 0 && i < (control.children.length - 1) ?
                            <div className="d-flex mb-3">
                                <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => this.tabChange(control.children[i - 1].formid ? control.children[i - 1].formid : control.children[i - 1].id)}>
                                    <i className="fa fa-arrow-left pr-2"></i>{control.optionabuttonPrevText ? control.optionabuttonPrevText : control.children[i - 1].Header}
                                </button>
                                <button type="button" onClick={() => this.tabChange(control.children[i + 1].formid ? control.children[i + 1].formid : control.children[i + 1].id)} className="btn btn-outline-primary btn-sm ml-auto">
                                    {control.optionabuttonText ? control.optionabuttonText : control.children[i + 1].Header}
                                    <i className="fa fa-arrow-right pl-2"></i>
                                </button>
                            </div>
                            : i == control.children.length - 1 ?
                                <div className="d-flex mb-3">
                                    <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => this.tabChange(control.children[i - 1].formid ? control.children[i - 1].formid : control.children[i - 1].id)}>
                                        <i className="fa fa-arrow-left pr-2"></i>{control.optionabuttonPrevText ? control.optionabuttonPrevText : control.children[i - 1].Header}
                                    </button>
                                </div>
                                : null}
                </div>
                : null}
        </Tab>;
    }
    renderTabNoExtForm(tab, action, formid, control, i, isDisable) {
        return <Tab disabled={isDisable} key={tab.id} eventKey={tab.label} title={<span>{tab.tabicon ? <i className={tab.tabicon + " icon-remove"} /> : null} {tab.Header} </span>}>
            {<div className="row">

                {Array.isArray(tab.children) && tab.children.map(ctr => {
                    return (
                        ControlService().renderControls(ctr, action, formid)
                    );
                })}
                {control.showoptionabutton ?
                    <div className="col-12 pt-3">
                        {i == 0 ?
                            <div className="d-flex justify-content-end mb-3">
                                <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => this.props.update(control.key, control.children[i + 1].label, formid + action)}>
                                    <i className="fa fa-arrow-right pl-2"></i>{control.optionabuttonText ? control.optionabuttonText : control.children[i + 1].Header}
                                </button>
                            </div>
                            : i > 0 && i < (control.children.length - 1) ?
                                <div className="d-flex mb-3">
                                    <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => this.props.update(control.key, control.children[i - 1].label, formid + action)}>
                                        <i className="fa fa-arrow-left pr-2"></i>{control.optionabuttonPrevText ? control.optionabuttonPrevText : control.children[i - 1].Header}
                                    </button>
                                    <button type="button" onClick={() => this.props.update(control.key, control.children[i + 1].label, formid + action)} className="btn btn-outline-primary btn-sm ml-auto">
                                        {control.optionabuttonText ? control.optionabuttonText : control.children[i + 1].Header}
                                        <i className="fa fa-arrow-right pl-2"></i>
                                    </button>
                                </div>
                                : i == control.children.length - 1 ?
                                    <div className="d-flex mb-3">
                                        <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => this.props.update(control.key, control.children[i - 1].label, formid + action)}>
                                            <i className="fa fa-arrow-left pr-2"></i>{control.optionabuttonPrevText ? control.optionabuttonPrevText : control.children[i - 1].Header}
                                        </button>
                                    </div>
                                    : null}
                    </div>
                    : null}
            </div>}

        </Tab>;
    }
    renderImageButtonView(opt, control, data) {
        return <div key={opt.id} className={"col col-" + control.imageboxwidth}>
            <div className={"check-img " + (control.leftimg ? 'left-img' : 'top-img')}>
                <label className={"check-img-control " + (control.hideborder ? 'border-0' : '')}>
                    {data[control.key] == opt.label ?
                        <input aria-label={opt.label} type="radio" checked="checked" name={control.key} onChange={(e) => { this.ResetChildren(opt, control); }} value={opt.label}
                            className="check-img-input" />
                        :
                        <input aria-label={opt.label} type="radio" name={control.key} onChange={(e) => { this.ResetChildren(opt, control); }} value={opt.label}
                            className="check-img-input" />}
                    <span className={"d-flex " + (control.leftimg ? 'flex-row align-items-center' : 'flex-column')}>
                        <span
                            style={{
                                'backgroundImage': 'url(' + opt.imageUrl + ')',
                                'backgroundSize': control.backgroundsize,
                                'height': control.imageheight,
                                'width': control.imgwidth
                            }}
                            className="check-img-img align-self-center"></span>
                        <span className="check-img-description">
                            {opt.tabicon && <i className={opt.tabicon + " " + (opt.Header ? 'mr-2' : '')}></i>}
                            <span>{opt.Header ? opt.Header : opt.label}</span>
                            {opt.subheader && <span className="small text-muted">{opt.subheader}</span>}
                        </span>
                    </span>
                    <span className="tic-mark">
                        <i className="fa fa-check-circle fa-lg"></i>
                    </span>
                </label>
            </div>
        </div>;
    }
    renderExtButtonView(opt, control) {
        return <div key={opt.id} className={"col col-" + control.imageboxwidth}>
            <div className={"check-img " + (control.leftimg ? 'left-img' : 'top-img')}>
                <label className="check-img-control">
                    <input aria-label={opt.Header ? opt.Header : opt.label} type="radio" name={control.key} onChange={(e) => { this.ResetChildren(opt, control); }} value={opt.label}
                        className="check-img-input" />
                    <span className={"d-flex " + (control.leftimg ? 'flex-row align-items-center' : 'flex-column')}>
                        <span
                            style={{
                                'backgroundImage': 'url(' + opt.imageUrl + ')',
                                'backgroundSize': control.backgroundsize,
                                'height': control.imageheight,
                                'width': control.imgwidth
                            }}
                            className="check-img-img align-self-center"></span>
                        <span className="check-img-description">
                            {opt.tabicon && <i className={opt.tabicon + " " + (opt.Header ? 'mr-2' : '')}></i>}
                            <span>{opt.Header ? opt.Header : opt.label}</span>
                            {opt.subheader && <span className="small text-muted">{opt.subheader}</span>}
                        </span>
                    </span>
                    <span className="tic-mark">
                        <i className="fa fa-check-circle fa-lg"></i>
                    </span>
                </label>
            </div>
        </div>;
    }
    renderTabButtonView(opt, control) {
        return <div key={opt.id} className={"btn btn-circle " + (this.state.selectedTabKey == opt.label ? 'btn-secondary' : 'btn-outline-secondary')}>
            <label className="btn-circle-inner mb-0">
                <input type="radio" aria-label={opt.Header} name="control.key" checked={this.state.selectedTabKey == opt.label} onChange={(e) => this.ResetChildren(opt, control)} value={opt.label} />
                <span>{opt.Header}</span>
            </label>
        </div>;
    }
    render() {
        const { control, action, formid } = this.props;

        var data = this.props.data[formid + action] ? this.props.data[formid + action] : {};
        if (isBrowser) {
            if (!control.IsButtonView && !control.IsImageButtonView && !control.IsExternalFormLoad) {
                return (
                    <div className={"tab-card " + (control.hideborder ? ' border-0 ' : null) + (control.bgtransparent ? 'bg-transparent' : null)}>
                        <Tabs activeKey={this.state.selectedTabKey} animation="false"
                            onSelect={(e) => { this.setState({ selectedTabKey: e }, () => this.props.update(control.key, e, formid + action)) }}
                            id={control.id}>
                            {
                                control.children.map((tab, i) => {
                                    return (
                                        actionType(tab.rules) === 'hide' || actionType(tab.rules) === 'show' ?
                                            ruleCheck(tab.rules, data, this.props.data) ? this.renderTabNoExtForm(tab, action, formid, control, i, false) : null
                                            : actionType(tab.rules) === 'disable' || actionType(tab.rules) === 'enable' ?
                                                this.renderTabNoExtForm(tab, action, formid, control, i, true)
                                                : this.renderTabNoExtForm(tab, action, formid, control, i, false)
                                    )
                                })
                            }
                        </Tabs>
                    </div>
                )
            } else if (control.IsButtonView && !control.IsImageButtonView && !control.IsExternalFormLoad) {
                return (
                    <div>
                        {action == 'write' ?
                            <div className="form-group">
                                {control.label &&
                                    <label>
                                        {/* {data[control.key] && data[control.key] != '' ? <i className="text-primary fa fa-check-circle-o fa-lg pr-2"></i> : null} */}
                                        {control.label}
                                    </label>
                                }
                                <div className="d-flex">
                                    {
                                        control.children.map(tab => {
                                            return (
                                                actionType(tab.rules) === 'hide' || actionType(tab.rules) === 'show' ?
                                                    ruleCheck(tab.rules, data, this.props.data) ? this.renderTabButtonView(tab, control, false) : null
                                                    : actionType(tab.rules) === 'disable' || actionType(tab.rules) === 'enable' ?
                                                        <div key={uuidv4()} style={{ 'position': 'relative' }}>
                                                            <div style={{
                                                                'position': 'absolute',
                                                                'height': '100%',
                                                                'width': '100%',
                                                                'zIndex': '1',
                                                                'opacity': '0.3'
                                                            }} hidden={ruleCheck(tab.rules, data, this.props.data)}></div>
                                                            {this.renderTabButtonView(tab, control)}
                                                        </div>
                                                        : this.renderTabButtonView(tab, control, false)
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            :
                            null
                        }
                        <div className="row">
                            <div className="col-12">
                                <div className="tab-content">
                                    {this.state.selectedTab ?
                                        <div className="row">
                                            {
                                                this.state.selectedTab.children.map(ctr => {
                                                    return (
                                                        ControlService().renderControls(ctr, action, formid)
                                                    )
                                                })
                                            }
                                        </div>
                                        : null}
                                </div>
                            </div >
                        </div >
                    </div >
                )
            } else if (control.IsImageButtonView && !control.IsExternalFormLoad) {
                return (
                    <div className="wizard">
                        <div className="wizard-inner-top pt-10">
                            <div className="form-group">
                                {control.label.length > 0 ?
                                    <h6 className="d-block pb-10">
                                        {data[control.key] && data[control.key] != '' ? <i className="secondary-text fa fa-check-square-o pr-2"></i> : null}
                                        {control.label}
                                    </h6>
                                    : null}
                                <div className="row check-img-outer">
                                    {
                                        control.children.map(tab => {
                                            return (
                                                actionType(tab.rules) === 'hide' || actionType(tab.rules) === 'show' ?
                                                    ruleCheck(tab.rules, data, this.props.data) ? this.renderImageButtonView(tab, control, data) : null
                                                    : actionType(tab.rules) === 'disable' || actionType(tab.rules) === 'enable' ?
                                                        <div key={uuidv4()} style={{ 'position': 'relative' }}>
                                                            <div style={{
                                                                'position': 'absolute',
                                                                'height': '100%',
                                                                'width': '100%',
                                                                'zIndex': '1',
                                                                'opacity': '0.3'
                                                            }} hidden={ruleCheck(tab.rules, data, this.props.data)}></div>
                                                            {this.renderImageButtonView(tab, control, data)}
                                                        </div>
                                                        : this.renderImageButtonView(tab, control, data)
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">

                                <div className="tab-content">
                                    {this.state.selectedTab ?
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    {
                                                        this.state.selectedTab.children.map(ctr => {
                                                            return (
                                                                ControlService().renderControls(ctr, action, formid)
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        : null}
                                    <div className="clearfix"></div>
                                </div>

                            </div >
                        </div >
                    </div >
                )
            } else if (control.IsExternalFormLoad && !control.IsImageButtonView) {
                return (
                    <div className="tab-card">
                        <Tabs activeKey={this.state.selectedTabKey != 0 ? this.state.selectedTabKey : control.children[0].formid} animation="false"
                            onSelect={(e) => this.tabChange(e)}
                            id={control.id}>
                            {this.loadTab(control, data)}
                        </Tabs>
                    </div >
                )
            } else if (control.IsImageButtonView && control.IsExternalFormLoad) {
                return (
                    <div>
                        <div className="wizard">
                            <div className="wizard-inner-top pt-10">
                                <div className="form-group">

                                    <div className="row check-img-outer">
                                        {
                                            control.children.map((tab) => {
                                                return (
                                                    actionType(tab.rules) === 'hide' || actionType(tab.rules) === 'show' ?
                                                        ruleCheck(tab.rules, data, this.props.data) ? this.renderExtButtonView(tab, control) : null
                                                        : actionType(tab.rules) === 'disable' || actionType(tab.rules) === 'enable' ?
                                                            <div key={uuidv4()} style={{ 'position': 'relative' }}>
                                                                <div style={{
                                                                    'position': 'absolute',
                                                                    'height': '100%',
                                                                    'width': '100%',
                                                                    'zIndex': '1',
                                                                    'opacity': '0.3'
                                                                }} hidden={ruleCheck(tab.rules, data, this.props.data)}></div>
                                                                {this.renderExtButtonView(tab, control)}
                                                            </div>
                                                            : this.renderExtButtonView(tab, control)
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div >
                        <div className="row">
                            <div className="col-12">
                                <div className="tab-content">
                                    {this.state.selectedTab && this.state.advanceSearchformJson && !this.state.isApiCalling ?
                                        <div className="row">
                                            {this.state.advanceSearchformJson.controls.map(ctrl => {
                                                return (

                                                    this.state.selectedTab.formactiontype != 'filter' && !ctrl.filterresult ?
                                                        ControlService().renderControls(ctrl, this.state.selectedTab.formactiontype, this.state.selectedTab.formid)
                                                        :
                                                        this.state.selectedTab.formactiontype == 'filter' && ctrl.filterresult ?
                                                            ControlService().renderControls(ctrl, this.state.selectedTab.formactiontype, this.state.selectedTab.formid)
                                                            : null

                                                )
                                            })}
                                        </div>
                                        : <Loading token={this.props.token} enable={this.state.isApiCalling} />
                                    }
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                        </div >
                    </div >
                )
            }
            else {
                return null
            }
        } else {
            if (!control.IsExternalFormLoad) {
                return (
                    <React.Fragment>
                        {control.children.map(opt => {
                            return (
                                <div className='card' key={opt.id}>
                                    <div className='card-header' onClick={(e) => { this.ResetChildren(opt, control) }}>
                                        <span>{opt.Header ? opt.Header : opt.label}</span>
                                    </div>

                                    {this.state.selectedTab && (opt.label == this.state.selectedTabKey) &&
                                        <div className='card-body'>
                                            {
                                                this.state.selectedTab.children.map(ctr => {
                                                    return (
                                                        <div key={ctr.id} className='row'>
                                                            {ControlService().renderControls(ctr, action, formid)}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    }
                                </div>
                            )
                        })}
                    </React.Fragment>
                )
            }
        }
    }
}

export default connect(
    mapStateToProps, bindAction
)(TabUI);